import { supabase } from '../services/supabase';
import { channelName, obsChannelName } from './remoteProtocol';

/**
 * Joins a Supabase Realtime Broadcast channel by name.
 *
 * Returns { send(message), close() } or null when Supabase is not configured.
 * `onMessage(payload)` receives messages from the other side (never our own);
 * `onStatus('connecting' | 'connected' | 'offline')` reports the connection.
 * Realtime reconnects by itself, so status simply follows it.
 */
function openBroadcast(name, { onMessage, onStatus }, client) {
  if (!client) return null;
  const channel = client.channel(name, { config: { broadcast: { self: false } } });

  channel.on('broadcast', { event: 'msg' }, ({ payload }) => {
    if (payload && typeof payload === 'object') onMessage(payload);
  });

  onStatus('connecting');
  channel.subscribe((status) => {
    if (status === 'SUBSCRIBED') onStatus('connected');
    else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT' || status === 'CLOSED') onStatus('offline');
  });

  return {
    send(message) {
      // Fire and forget: a message lost while offline is replaced by the next heartbeat.
      Promise.resolve(channel.send({ type: 'broadcast', event: 'msg', payload: message })).catch(() => {});
    },
    close() {
      Promise.resolve(client.removeChannel(channel)).catch(() => {});
    },
  };
}

// Phone remote <-> console.
export function openRemoteChannel(code, handlers, client = supabase) {
  return openBroadcast(channelName(code), handlers, client);
}

// Console -> /obs livestream page.
export function openObsChannel(code, handlers, client = supabase) {
  return openBroadcast(obsChannelName(code), handlers, client);
}
